import RoomElement from './RoomElement'
import RGBA from '../../Fonts/RGBA'
import colorSchemeRepository from '../../Images/ColorSchemeRepository'

let radius = 15;

export default class BackgroundRenderer extends RoomElement
{

  render(ctx)
  {

    let stage = this.room.getStage();

    ctx.moveTo(this.scale(radius), this.scale(this.roomHeight()));

    // bottom left
    ctx.quadraticCurveTo( this.scale(0), this.scale(this.roomHeight()), this.scale(0), this.scale(this.roomHeight() - radius));

    // if we have a stage we won't render the upper half of our room, as it will be covered with the stage
    if (stage) {

      // left
      ctx.lineTo(this.scale(0), this.scale(stage.height));

      // top
      ctx.lineTo(this.scale(this.roomWidth()), this.scale(stage.height));

    }
    else{

      // left
      ctx.lineTo(this.scale(0), this.scale(radius));

      // top left corner
      ctx.quadraticCurveTo( this.scale(0), this.scale(0), this.scale(radius), this.scale(0));

      // top
      ctx.lineTo(this.scale(this.roomWidth() - radius), this.scale(0));

      // top right corner
      ctx.quadraticCurveTo( this.scale(this.roomWidth()), this.scale(0), this.scale(this.roomWidth()), this.scale(radius));


    }

    // right
    ctx.lineTo(this.scale(this.roomWidth()), this.scale(this.roomHeight() - radius));
    ctx.quadraticCurveTo(this.scale(this.roomWidth()), this.scale(this.roomHeight()), this.scale(this.roomWidth() - radius), this.scale(this.roomHeight()));

    ctx.fillStyle = colorSchemeRepository.get('roomBackground');
    ctx.fill();




  }


}
